<template>
  <el-form :model="form" :rules="getrules" ref="ruleForm" label-width="120px" :validate-on-rule-change="false">
    <el-form-item label="图标素材" prop="icon">
      <el-upload class="ads-avatar-uploader" action="#" :show-file-list="false" :http-request="handleUpload">
        <div v-loading="upload_loading">
          <img v-if="form.icon" :src="form.icon" class="ads-avatar">
          <i v-else class="el-icon-plus ads-avatar-uploader-icon"></i>
        </div>
      </el-upload>
      <p style="font-size: 12px;color: #999;margin-top: 10px;">尺寸：160*160 到 512*512 之间，并且比例相同，格式：png、jpg、jpeg，最大不超过：10MB</p>
    </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
    </el-form-item>
    <el-form-item label="文案" prop="description" >
      <el-input v-model="form.description" placeholder="请输入文案"></el-input>
    </el-form-item>
    <!-- <el-form-item label="渠道包ID" prop="channel_package_id">
      <el-row>
        <el-col :span="20">
          <el-select v-model="form.channel_package_id" placeholder="请选择渠道包ID" filterable remote
            :remote-method="remoteMethodPackage" :loading="package_loading" style="width: 100%;">
            <el-option v-for="item in package_list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-left: 10px;">
          <Countdown @click="handleUpdatePackage" />
        </el-col>
      </el-row>
    </el-form-item> -->
    <el-form-item label="智能分包渠道号" prop="channel_pkg_number">
      <el-row>
        <el-col :span="20">
          <ESelect v-model="form.channel_pkg_number" placeholder="请选择渠道包ID" filterable remote
            :remote-method="remoteMethodPkg" :loading="channel_pkg_number_loading" style="width: 100%;" clearable>
            <el-option v-for="item in channel_pkg_number_list" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </ESelect>
        </el-col>
        <el-col :span="4" style="padding-left: 10px;">
          <!-- <el-button type="primary" @click="handleUpdatePkg" :disabled="industry_disabled">更新{{ industry_disabled ?
            industry_countdown : null }}</el-button> -->
          <Countdown @click="handleUpdatePkg" />
        </el-col>
      </el-row>

    </el-form-item>
    <el-form-item label="创意行业" prop="industry_id">
      <el-cascader v-model="form.industry_id" :options="industry_list" placeholder="请输入创意行业"
        @change="handleChangeIndustry" style="width: 100%;" popper-class="ads_industry_list_popper cascader-x-scroll-auto" clearable
        :props="{emitPath:false}"
        ></el-cascader>
    </el-form-item>
    <el-form-item label="创意标签" prop="industry_labels">
      <ESelect v-model="form.industry_labels" multiple placeholder="请输入创意标签" style="width: 100%;">
        <el-option v-for="item in industry_labels_list" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </ESelect>
    </el-form-item>
    <el-form-item label="品牌名称" prop="corporate">
      <el-input v-model="form.corporate" placeholder="请输入品牌名称"></el-input>
    </el-form-item>
    <template v-if="!isQuickApp">
      <el-form-item label="落地页链接" prop="landing_page_type">
        <el-radio-group v-model="form.landing_page_type">
          <el-radio-button label="LANDING_PAGE_TYPE_USER_DEFINED">自定义落地页</el-radio-button>
          <el-radio-button label="LANDING_PAGE_TYPE_APP">维纳斯落地页</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="自定义落地页" prop="landing_page_1" v-if="form.landing_page_type == 'LANDING_PAGE_TYPE_USER_DEFINED'">
        <el-input v-model="form.landing_page_1" placeholder="请输入自定义落地页"></el-input>
      </el-form-item>
      <el-form-item label="维纳斯落地页" prop="landing_page_2" v-if="form.landing_page_type == 'LANDING_PAGE_TYPE_APP'">
        <el-col :span="20">
          <ESelect v-model="form.landing_page_2" placeholder="请选择维纳斯落地页" style="width: 100%;">
            <el-option :label="item.label" :value="item.value" v-for="(item, index) in venus_list"
              :key="index"></el-option>
          </ESelect>
        </el-col>
        <el-col :span="4" style="padding-left: 10px;">
          <Countdown @click="handleUpdateVenus" />
        </el-col>
      </el-form-item>
    </template>
    <el-form-item v-if="!isQuickApp" :label="'应用直达链接'" prop="deeplink" >
      <el-input v-model="form.deeplink" :placeholder="'请输入应用直达链接'"></el-input>
    </el-form-item>
    <el-form-item v-else :label="'deeplink链接'" prop="deep_link_url" >
      <el-input v-model="form.deep_link_url" :placeholder="'请输入deeplink链接'"></el-input>
    </el-form-item>
    <el-form-item prop="impression_monitor_url">
      <template #label>
				曝光监测链接
				<el-tooltip effect="dark"
					placement="top-start">
          <div slot="content" style="max-height: 40vh;overflow-y: auto;">
            <div>曝光监测链接的前缀必须是一下url：</div>
            <div v-html="unHttpHtml"></div>
          </div>
					<i class="el-icon-question" style="cursor: pointer;" />
				</el-tooltip>
			</template>
      <el-input v-model="form.impression_monitor_url" placeholder="请输入曝光监测链接"></el-input>
    </el-form-item>
    <el-form-item prop="click_monitor_url">
      <template #label>
				点击监测链接
				<el-tooltip effect="dark"
					placement="top-start">
          <div slot="content" style="max-height: 40vh;overflow-y: auto;">
            <div>监测地址的前缀必须是一下url：</div>
            <div v-html="unHttpHtml"></div>
          </div>
					<i class="el-icon-question" style="cursor: pointer;" />
				</el-tooltip>
			</template>
      <el-input v-model="form.click_monitor_url" placeholder="请输入点击监测链接"></el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import _ from 'lodash'
import Countdown from '@/views/marketingManagement/configuration/components/countdown.vue'
import Huaweiads from '@/libs/cos/Huaweiads.js'
import getMediaInfo from '@/libs/media';
import { unHttp } from './unHttp.js'
import {
  BatchPackageListApi,
  BatchPackageListUpdateApi,
  BatchIntelligentPackageListApi,
  BatchIntelligentPackageListUpdateApi,
} from '@/api/marketManage/configuration.js'
import { postBatchPromotionVenusUpdateApi } from '@/api/marketManage/huaweiAds.js'
export default {
  name: 'FormGroup',// 'fill', 'contain', 'cover', 'none', 'scale-down'
  components: {
    Countdown
  },
  props: {
    rootFormData: {
      type: Object,
      default: () => { }
    },
    product: {
      type: [String, Number],
    },
    industry_list: {
      type: Array,
      default: () => []
    },
    venus_list: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    isQuickApp: Boolean,
    isHarmonyOS: Boolean,
  },
  data() {
    return {
      // rules: {
      //   title: [
      //     { required: true, message: '请输入文案', trigger: 'blur' },
      //     { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
      //   ]
      // }
      unHttp: unHttp,
      upload_loading: false,
      package_loading: false,
      package_list: [],
      channel_pkg_number_loading: false,
      channel_pkg_number_list: [],
      industry_labels_list: [],
      package_disabled: false,
      package_countdown: 120,
      industry_disabled: false,
      industry_countdown: 120,
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      }
    },
    getrules() {
      return this.$props.rules
    },
    unHttpHtml() {
      let html = this.unHttp.join('<br/>')
      return `<div>${html}</div>`
    }
  },
  watch: {
    'form.landing_page_type': {
      handler() {
        // this.$refs?.ruleForm?.clearValidate()
        // this.$refs.ruleForm.clearValidate(['landing_page_1', 'landing_page_2'])
      }
    },
    'product': {
      handler(newval) {
        if (!newval) return
        if (!newval?.channel_pkg_number) {
          this.remoteMethodPkg('')
        }else{
          this.remoteMethodPkg(newval?.channel_pkg_number)
        }
      },
      immediate: true
    },
    'form.industry_id': {
      handler(newval) {
        if (!newval || newval.length == 0) {
          this.industry_labels_list = []
          this.form.industry_labels = []
        }
      },
      deep: true
    }
  },
  created() {
    this.resetForm()
  },
  methods: {
    remoteMethodPackage: _.throttle(async function (query) {
      if (!query) {
        this.package_list = [];
        return;
      }
      let res = await BatchPackageListApi({
        plat_id: 10,
        account_id: this.rootFormData.account_id,
        app_id: this.product,
        search: query
      })
      this.package_list = [
        {
          label: '1111',
          value: '1111'
        }
      ]
    }, 300),
    remoteMethodPkg: _.throttle(async function (query) {
      // if (!query) {
      //   this.channel_pkg_number_list = [];
      //   return;
      // }
      try {
        let res = await BatchIntelligentPackageListApi({
          plat_id: 10,
          account_id: this.rootFormData.account_id,
          app_id: this.product,
          search: query
        })
        this.channel_pkg_number_list = res.data.list
      } catch (error) {
        this.$message.error(error.info)
      }
    }, 300),
    handleUpdatePackage() {
      this.$notify({
        type: 'info',
        title: '提示',
        message: '请求成功',
      })
      BatchPackageListUpdateApi({
        account_id: this.rootFormData.account_id,
        plat_id: 10,
      }).then(res => {
        // this.$emit('updateFetch', 'channel_package_id')
        this.remoteMethodPkg(this.rootFormData?.channel_pkg_number || '')
        this.$notify.closeAll()
        this.$notify({
          type: 'success',
          title: '提示',
          message: '更新成功',
        })
      })
    },
    handleUpdatePkg() {
      this.$notify({
        type: 'success',
        title: '提示',
        message: '请求成功',
      })
      BatchIntelligentPackageListUpdateApi({
        account_id: this.rootFormData.account_id,
        plat_id: 10,
      }).then(res => {
        this.$notify.closeAll()
        this.$notify({
          type: 'success',
          title: '提示',
          message: '更新成功',
        })
      }).catch(err => {
        this.$notify.closeAll()
         this.$notify({
          type: 'error',
          title: '更新失败',
          message: err.info,
        })
      })
    },
    handleUpdateVenus() {
      this.$notify({
        type: 'success',
        title: '提示',
        message: '请求成功',
      })
      postBatchPromotionVenusUpdateApi({
        account_id: this.rootFormData.account_id,
        plat_id: 10,
      }).then(res => {
        this.$emit('updateFetch', 'venus_list')
        this.$notify.closeAll()
        this.$notify({
          type: 'success',
          title: '提示',
          message: '更新成功',
        })
      }).catch(err => {
          this.$notify.closeAll()
         this.$notify({
          type: 'error',
          title: '更新失败',
          message: err.info,
        })
      })
    },
    handleChangeIndustry(value) {
      let flat_array = this.findItemByValue(this.industry_list, value)
      this.industry_labels_list = flat_array?.labels?.map(item => ({ label: item, value: item }))
      this.form.industry_labels = []
    },
    findItemByValue(arr, value) {
      // 遍历每个项，递归查找
      for (let item of arr) {
        // 如果当前项匹配
        if (item.value === value) {
          return item; // 返回当前项
        }
        // 如果有 children，则递归查找
        if (item.children) {
          const found = this.findItemByValue(item.children, value);
          if (found) return found; // 找到匹配的子项
        }
      }
      return null; // 没有找到则返回 null
    },
    async handleUpload({ file }) {
      // 上传前校验文件
      const media = await getMediaInfo(file);
      const { format, fileSize, height, width } = media;
      // 获取文件后缀名 考虑有多个.的情况
      let file_name = file.name
      const index = file_name.lastIndexOf('.')
      let suffix = file_name.substring(index + 1);
      // 添加验证逻辑
      const maxSize = 10 * 1024 * 1024; // 10MB
      const validFormats = ['png', 'jpg', 'jpeg'];
      const minWidth = 160;
      const minHeight = 160;
      const maxWidth = 512;
      const maxHeight = 512;

      if (!validFormats.includes(suffix.toLowerCase())) {
        this.$message.error('文件格式必须为 png、jpg 或 jpeg');
        return;
      }

      if (fileSize > maxSize) {
        this.$message.error('文件大小不能超过 10MB');
        return;
      }

      if (width < minWidth || height < minHeight || width > maxWidth || height > maxHeight) {
        this.$message.error('图片尺寸必须在 160*160 到 512*512 之间，并且比例相同。');
        return;
      }

      if (width !== height) {
        this.$message.error('图片尺寸必须在 160*160 到 512*512 之间，并且比例相同。');
        return;
      }

      this.upload_loading = true
      const result = await Huaweiads.putObject(file);
      if (result?.statusCode == 200) {
        let location = result.full_path
        this.form.icon = location;
      }
      this.upload_loading = false
    },
    submitForm: async function () {
      try {
        console.log('this.$refs.ruleForm', this.$refs.ruleForm)
        let result = await this.$refs.ruleForm.validate();
        return Promise.resolve(this.form)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    resetForm() {
      this.$refs?.ruleForm?.clearValidate();
    }
  }
}
</script>
<style>
.ads-avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.ads-avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.ads-avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
}

.ads-avatar {
  width: 108px;
  height: 108px;
  display: block;
}

.ads_industry_list_popper .el-cascader-panel {
  max-height: 360px;
  min-height: 100px;
  /* 设置最大高度，根据需要调整 */
}
</style>
